import { DialogUnsavedChanges } from './DialogUnsavedChanges';

export default { UnsavedChanges: DialogUnsavedChanges };
